var React = require('react');

function FiltersIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.586A2 2 0 0 1 21.414 7L15 13.414V20a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-6.586L2.586 7A2 2 0 0 1 2 5.586V4zm18 0H4v1.586L10.414 12A2 2 0 0 1 11 13.414V20h2v-6.586A2 2 0 0 1 13.586 12L20 5.586V4z"}));
}

FiltersIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FiltersIcon;

FiltersIcon.default = FiltersIcon;
